<template>
    <div class="vm-dashboard-header" :class="[browser_size]">
        <avatar v-if="session_user" :is_no_href="true" :badge_size="16" @click.native="$mixin_router_push($userlink(session_user).path)" class="mq-80-64" :user="session_user" :name_center="true">
            <div slot="right" class="flex-box flex-align-self-center pt16 pb16">
              <i class="afd afd-arrow-right purple fs16"></i>
            </div>
        </avatar>
        <div class="flex-box mt16 flex-justify-content-space-between">
          <div class="flex-box flex-align-items-center">
            <tag class="mr16 gray circle" @click.native="$mixin_router_push('/setting/account')">{{$t('c.DashboardHeader.text1')}}</tag>
            <tag v-if="!is_applying_apple && !is_applying_google && is_creator" class="gray circle" @click.native="$mixin_router_push('/setting/creator')">{{$t('c.DashboardHeader.text2')}}</tag>
          </div>
          <div v-if="is_creator" class="flex-box flex-align-items-center black-2">
              <i class="afd afd-link fs16 black-8" @click="copy"></i>
              <i class="afd afd-qrcode fs16 ml18 black-8" @click="$mixin_show_modal_share_img({val: `https://afdian.net/u/${session_user.user_id}`,user: session_user})"></i>
              <share class="ml18 fs16 black-8" :is_only_icon="true" :config="share_config"></share>
          </div>
        </div>
        <div v-if="is_creator && !is_applying_apple && !is_applying_google" class="flex-box mt16 lh1 flex-align-items-center flex-justify-content-space-between">
            <!-- <span @click="$mixin_router_push('/setting/plan')" class="black-8 fs14 fwb tab-box flex-item-1 text-center" v-if="plans && plans.length > 0" :class="{mr8: plan_sale_list && plan_sale_list.length > 0}">{{$t('c.DashboardHeader.text3')}} {{plans.length}}</span> -->
            <span @click="$mixin_router_push('/setting/plan')" class="black-8 fs14 fwb tab-box flex-item-1 text-center" v-if="plans && plans.length > 0" :class="{mr8: plan_sale_list && plan_sale_list.length > 0}">{{$t('c.DashboardHeader.text3')}} {{plans.length}}</span>
            <span @click="$mixin_router_push('/setting/shop')" class="black-8 fs14 fwb tab-box flex-item-1 text-center ml8" v-if="plan_sale_count > 0">{{$t('c.DashboardHeader.text4')}} {{plan_sale_count}}</span>
        </div>
        <div v-if="!is_creator && !is_applying_apple && !is_applying_google" class="mt32">
            <btn class="size48 mq" @click.native="$mixin_router_push('/apply')">{{$t('c.DashboardHeader.text5')}}</btn>
        </div>
    </div>
</template>

<script>
import {
  GET_SESSION_USER,
  GET_PRODUCTS
} from "@/api/config";
import { mapState } from "vuex";
export default {
  name: "dashboard-header",
  props: {
    type: {
      default() {
        return "1";
      }
    }
  },
  components: {},
  data() {
    return {
        has_load:false,
        plan_sale_count:0,
    };
  },
  computed: {
    ...mapState("app", ['browser_size',"session_user","is_applying_apple","is_applying_google"]),
    ...mapState('order', [
      'plans',
    ]),
    share_config() {
      // let url = location.origin + this.$route.path + `?tab=${this.type}`
      return {
        url: this.url,
        source: `${location.origin}`,
        title: `${this.session_user ? this.session_user.name : ""}正在创作${
          this.session_user ? this.session_user.creator.doing : ""
        } | 爱发电`,
        description: `欢迎大家去${
          this.session_user && this.session_user.name
        }的爱发电主页逛逛！投喂能使他更好地创作~（分享自@爱发电）`,
        pic: this.session_user && this.session_user.avatar,
        is_no_weibo: true,
        share_user: this.session_user,
        extra_btns: [
          {
            func_name: "share_user",
            param: {
              user: this.session_user,
            },
            icon: `${this.GL.PIC_HOST}/static/img/icon-saveimage.png`,
            title: "保存图片并分享",
          },
        ],
      };
    },
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    },
    url(){
      return `https://afdian.net${this.$userlink(this.session_user).path}`
    }
  },
  async mounted() {
    let has_login = await this.$mixin_waitting_api(GET_SESSION_USER)
    if(has_login){
      this.get_products()
      await this.$store.dispatch('order/get:plans', {
        user_id: this.session_user.user_id,
      });
    }
    this.has_load = true;
  },
  methods: {
    copy() {
      this.mixin_copy(this.url,{text:'已复制主页链接'}, () => {
        this.$emit("close");
      });
    },
    async get_products() {
      if (this.$http.is_run(GET_PRODUCTS)) {
        return false;
      }
      let data = await this.$http.$axios(GET_PRODUCTS, {
        user_id: this.session_user.user_id,
      });
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: "error",
        });
        return false;
      }
      this.plan_sale_count = data.data.total_count;
    },
  }
};
</script>

<style lang="stylus" scoped>
.vm-dashboard-header {
  .vm-tag{
    padding:5px 12px;
  }
  .tab-box{
    padding:16px 12px;
    background:$gray;
    border-radius:4px;
  }
  &.small{

  }
}
</style>
